import * as React from "react";

// Components
// import Header from "../../Header";
// import Footer from "../../Footer";
// import IndicationAndSafetyDrawer from "../../IndicationAndSafety/Drawer/IndicationAndSafetyDrawer";
// import IndicationAndSafety from "../../IndicationAndSafety";
import WelcomeModal from "../../WelcomeModal";
import ScrollToTop from "../../ScrollToTop";
// Styles
import GlobalStyles from "../../../styles/global";
import { MultiBrandStyledLayout, MultiBrandPageMain } from "./styles";
import PageSeo from "../../Seo/PageSeo";
// import { useContext } from "react";

import Theme from "../../../util/globals/Theme";
import { SelectIndicationContextProvider } from "../../../context/SelectIndicationContext";
import useWindowSize from "../../../util/hooks/useWindowSize";
import MultiBrandHeader from "../MultiBrandHeader";
import MultiBrandIndicationAndSafetyPage from "../MultiBrandIndicationAndSafety";
import MultiBrandIndicationAndSafetyDrawer from "../MultiBrandIndicationAndSafety/Drawer/MultiBrandIndicationAndSafetyDrawer";
import MultiBrandFooter from "../MultiBrandFooter";


const MultiBrandPageLayout = ({ children, location, pageMeta }) => {
  const { width } = useWindowSize();
  const isMed = width > Theme.breakpoints.lg;
  const isMob = width < Theme.breakpoints.lg;

  const [isHcp, setIsHcp] = React.useState(true);

    React.useEffect(() => {
      if (typeof window !== "undefined") {
        const value = window.localStorage.getItem("isHCP");
        setIsHcp(value === "true");
      }
    }, []);

    // if (isHcp === null) {
    //   return null; // or <div>Loading...</div>
    // }

  let pageKey = "default";
  switch (location.pathname.split("/")[1].toLowerCase()) {
    case "von-hippel-lindau":
      pageKey = "vhl";
      break;
    case "advanced-renal-cell-carcinoma":
    case "component-examples":
      pageKey = "rcc";
      break;
    case "":
      pageKey = "mt";
      break;
    case "contact-us":
      pageKey = "ut";
      break;
    case "404":
    case "site-map":
      pageKey = "ut";
      break;
    case "adjuvant-renal-cell-carcinoma":
      pageKey = "arcc";
      break;
    default:
      pageKey = "mt";
      break;
  }

  return (
    <SelectIndicationContextProvider>
      <MultiBrandStyledLayout>
        
     {!isHcp && <WelcomeModal />}
        <PageSeo pageMeta={pageMeta} />
        <GlobalStyles isMVL={true} />
        <MultiBrandHeader pageKey={pageKey}/>
        
        {/* <IndicationAndSafetyDrawer location={location} /> */}
        <MultiBrandIndicationAndSafetyDrawer location={location} pageKey={pageKey} />
        <MultiBrandPageMain>{children}</MultiBrandPageMain>
        <MultiBrandIndicationAndSafetyPage pageKey={pageKey} />

        <ScrollToTop multiBrand />

        <MultiBrandFooter pageKey={pageKey} />

        
      </MultiBrandStyledLayout>
    </SelectIndicationContextProvider>
  );
};

export default MultiBrandPageLayout;
